import axiosInstance from '../libs/axiosInstance';

/**
 * Submits a proctoring violation to the backend.
 * @param {string} sessionId - The UUID of the quiz session.
 * @param {string} violationType - The type of violation (e.g. 'frame_exit', 'multiple_faces', 'head_turn', 'eye_wandering').
 * @param {object|string} details - Metadata about the violation.
 * @param {Blob} [screenshotBlob] - Optional video frame screenshot.
 */
export const submitViolation = async (sessionId, violationType, details = {}, screenshotBlob = null) => {
  const formData = new FormData();
  formData.append('violation_type', violationType);
  formData.append('details', typeof details === 'string' ? details : JSON.stringify(details));

  if (screenshotBlob) {
    formData.append('screenshot', screenshotBlob, 'screenshot.jpg');
  }

  const response = await axiosInstance.post(
    `/quiz-session/${sessionId}/proctoring/violations/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

/**
 * Submits a periodic webcam snapshot for identity re-verification.
 * @param {string} sessionId - The UUID of the quiz session.
 * @param {Blob} snapshotBlob - The captured webcam JPEG image blob.
 */
export const submitSnapshot = async (sessionId, snapshotBlob) => {
  const formData = new FormData();
  formData.append('snapshot_image', snapshotBlob, 'webcam.jpg');

  const response = await axiosInstance.post(
    `/quiz-session/${sessionId}/proctoring/snapshots/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 2 * 60 * 1000,// 2 minutes timeout
    }
  );
  return response.data;
};

/**
 * Fetches the proctoring report for a quiz session (for lecturer/admin review).
 * @param {string} sessionId - The UUID of the quiz session.
 */
export const getProctoringReport = async (sessionId) => {
  const response = await axiosInstance.get(`/quiz-session/${sessionId}/proctoring/report/`);
  return response.data;
};
